// src/PrivacyPolicy.jsx
function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '20px', fontFamily: 'Arial' }}>
      <h1>Privacy Policy</h1>
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      
      <h2>Information We Collect</h2>
      <p>EstatesFlow CRM collects information you provide directly to us, such as when you create an account, fill forms, or communicate with us.</p>
      
      <h2>How We Use Your Information</h2>
      <p>We use the information to provide, maintain, and improve our services, and to communicate with you.</p>
      
      <h2>Data Security</h2>
      <p>We implement appropriate technical and organizational measures to protect your personal information.</p>
      
      <h2>Contact Us</h2>
      <p>Email: support@estatesflow.com</p>
      <p>Address: Jikwoyi, AMAC Abuja, Nigeria</p>
    </div>
  )
}

export default PrivacyPolicy